import { ReactNode } from "react";

export const IntegrationCard = ({
  logo,
  title,
  description,
  switchComponent,
  footer,
}: {
  logo: ReactNode;
  title: string;
  description: string;
  switchComponent: ReactNode;
  footer?: ReactNode;
}) => {
  return (
    <div className="bg-gray-0 shadow-xs flex w-full flex-col justify-between rounded-2xl border border-gray-200 lg:w-80">
      <div className="flex flex-col gap-3 p-6">
        <div className="flex items-center justify-between">
          <div className="flex gap-x-3">
            {logo}
            <div className="flex items-center text-lg font-semibold text-gray-950">
              {title}
            </div>
          </div>
          {switchComponent}
        </div>
        <div className="text-sm font-medium text-gray-950">{description}</div>
      </div>
      {footer && (
        <div className="flex flex-row items-center justify-center border-t border-gray-200 py-4">
          {footer}
        </div>
      )}
    </div>
  );
};
